module.exports = __webpack_public_path__ + "static/media/no_foto_perfil_en.65263729.svg";